<template>
  <div class="reminder">
       <h2>{{reminderList.title}}</h2>
			 <div>
					<span v-for="(list,i) in reminderList.list" :key="i" >
						<span class="item" :class="{'current':i==reminderList.current}">{{list}}</span> <img v-if="i!=reminderList.list.length-1" src="@/assets/img/dataImport/next.svg" alt="">
					</span>
			 </div>
  </div>
</template>

<script>
  export default {
    name: 'reminder',
    props: {
       reminderList: {
       	type: String,
       	default: {},
       }
    },
    data () {
      return {

      }
    },
    mounted: function () {

    }
  }
</script>
<style scoped="scoped">
		h2{
			font-size:12px;
			font-weight:400;
			color:rgba(102,102,102,1);
			line-height:17px;
			text-align: center;
			margin-bottom: 17px;
		}
		.reminder>div{
			padding: 0 20px 20px 20px;
			display: flex;
      justify-content: center;
		}
		.item{
			padding: 7px 7px 8px 8px;
			font-size:14px;
			font-weight:500;
			color:rgba(66,106,198,1);
			line-height:20px;
			border-radius:5px;
			border:1px solid rgba(66,106,198,1);
		}
		.reminder img{
			margin: 0 20px;
		}
		.reminder .current{
			background:rgba(66,106,198,1);
			color: #fff;
		}
</style>
